import styled from "styled-components";

import { colors, desktopDropdownMenuShadow } from "../shared";

export const Wrapper = styled.div`
    background-color: ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 ? colors.whiteDuplicate : colors.dark};
    ${({ isHeroSearchV2 }) => isHeroSearchV2 && desktopDropdownMenuShadow};
    padding: 1.5625rem 1.875rem 1.875rem 1.875rem;
    display: inline-block;

    ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 &&
        `
            &.scrolledDown {
                background-color: ${colors.dark};

                p {
                    color: ${colors.whiteDuplicate};
                }
            }

            &.scrolledUp {
                background-color: ${colors.whiteDuplicate};

                p {
                    color: ${colors.dark};
                }
            }
        `};
`;
